import * as types from "./types";

export const getAuditList = (data) => {
  return {
    type: types.GET_AUDIT_LISTING,
    payload: data,
  };
};

export const setAuditQuestionnaireDetailById = (data) => {
  return {
    type: types.SET_AUDIT_QUESTIONNAIRE_DETAIL,
    payload: data,
  };
};

export const setAuditQuery = (query) => {
  return {
    type: types.SET_QUERY,
    payload: query,
  };
};

export const setAuditErrorCode = (code) => {
  return {
    type: types.SET_ERROR_CODE,
    payload: code,
  };
};

export const setMultipleCamera = (value) => {
  return {
    type: types.SET_MULTIPLE_CAMERA,
    payload: value,
  };
};